'use client';

var NOTIFY_ACTION;
(function (NOTIFY_ACTION) {
    NOTIFY_ACTION[NOTIFY_ACTION["SHOW"] = 0] = "SHOW";
    NOTIFY_ACTION[NOTIFY_ACTION["HIDE"] = 1] = "HIDE";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_NOTIFY_COUNT"] = 2] = "SET_NOTIFY_COUNT";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_LOADING"] = 3] = "SET_LOADING";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_NOTIFICATIONS"] = 4] = "SET_NOTIFICATIONS";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_FILTER"] = 5] = "SET_FILTER";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_NOTIFY_READ"] = 6] = "SET_NOTIFY_READ";
    NOTIFY_ACTION[NOTIFY_ACTION["PUSH_TO_NOTIFICATIONS"] = 7] = "PUSH_TO_NOTIFICATIONS";
    NOTIFY_ACTION[NOTIFY_ACTION["MAP_JOB_INVITATION_NOTIFICATIONS"] = 8] = "MAP_JOB_INVITATION_NOTIFICATIONS";
    NOTIFY_ACTION[NOTIFY_ACTION["SET_READ_JOB_INVITATION"] = 9] = "SET_READ_JOB_INVITATION";
})(NOTIFY_ACTION || (NOTIFY_ACTION = {}));
var FILTER_TYPE;
(function (FILTER_TYPE) {
    FILTER_TYPE[FILTER_TYPE["ALL"] = 0] = "ALL";
    FILTER_TYPE[FILTER_TYPE["UNREAD"] = 1] = "UNREAD";
    FILTER_TYPE[FILTER_TYPE["READ"] = 2] = "READ";
})(FILTER_TYPE || (FILTER_TYPE = {}));

export { FILTER_TYPE, NOTIFY_ACTION };
//# sourceMappingURL=action.js.map
